import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CmsPageComponent } from './cms-page/cms-page.component';
import { IndexComponent } from './index/index.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { accountDeletionRequestComponent } from './account-deletion-request/account-deletion-request.component';
@NgModule({
  declarations: [
    AppComponent,
    CmsPageComponent,
    IndexComponent,
    accountDeletionRequestComponent
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      maxOpened: 1,
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
